import React from 'react';

import {
  Grid,
  InputLabel,
  Button,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';


const accountInfoForm = (props) => {
  let blockquote = null;
  if (!props.editMode) {
    blockquote = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
          {"Let's get started with some basic information about you."}
        </blockquote>
        <br /><br />
      </React.Fragment>
    );
  }

  let genderField = null;

  if (!props.editMode) {
    genderField = (
      <Grid item md={6} xs={12} sm={6}>
        <InputField
          id="gender"
          config={props.inputs.gender}
          changed={event => props.inputChangedHandler(event, 'gender')}
        />
      </Grid>
    );
  }

  let buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Update
    </Button>
  );

  if (!props.editMode) {
    buttons = (
      <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
        Next
        <NextIcon />
      </Button>
    );
  }

  return (
    <React.Fragment>
      {blockquote}

      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="email"
            config={props.inputs.email}
            changed={event => props.inputChangedHandler(event, 'email')}
          />
        </Grid>
        {(!props.editMode && !props.hideBranchField) ? (
          <Grid item md={6} xs={12} sm={6}>
            <InputField
              id="bureau"
              config={props.inputs.bureau}
              changed={event => props.inputChangedHandler(event, 'bureau')}
              loadOptions={asyncSelectData.getBureauOptions}
            />
          </Grid>) : <Grid item md={6} xs={12} sm={6}>&nbsp;</Grid>}
        <Grid item md={6} xs={12} sm={6}>
          <InputLabel className={classes.formLabel}>Name<span style={{ color: "#ff0000" }}>*</span></InputLabel>
          <InputLabel className={classes.formLabel}>નામ<span style={{ color: "#ff0000" }}>*</span></InputLabel>
          <InputField
            id="first_name"
            config={props.inputs.first_name}
            changed={event => props.inputChangedHandler(event, 'first_name')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6} className={classes.justifyEnd}>
          <InputField
            id="last_name"
            config={props.inputs.last_name}
            changed={event => props.inputChangedHandler(event, 'last_name')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="country_code"
            config={props.inputs.country_code}
            changed={event => props.inputChangedHandler(event, 'country_code')}
            loadOptions={asyncSelectData.getCountryCodeOptions}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="phone"
            config={props.inputs.phone}
            changed={event => props.inputChangedHandler(event, 'phone')}
          />
        </Grid>
        {genderField}
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="lohana_connect_id"
            config={props.inputs.lohana_connect_id}
            changed={event => props.inputChangedHandler(event, 'lohana_connect_id')}
          />
        </Grid>
      </Grid>
      <br /><br />
      {buttons}
    </React.Fragment>
  );
};

export default accountInfoForm;



// WEBPACK FOOTER //
// ./src/profile/components/AccountInfoForm.js